// import React, {
//   createContext,
//   useState,
//   useContext,
//   useCallback,
//   useEffect,
//   useRef,
// } from "react";
// import APICall from "../Utility/APICall";
// import { paths } from "../Utility/Constants";
// import { useAuth } from "../Utility/AuthProvider";

// // Context for Payments data
// export const PaymentsContext = createContext();

// // Provider for Payments data
// export const PaymentsProvider = ({ children }) => {
//   const { jwt } = useAuth();
//   const [payments, setPayments] = useState([]);
//   const [groupedPayments, setGroupedPayments] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [nextPageToken, setNextPageToken] = useState(null);
//   const [hasInitiallyLoaded, setHasInitiallyLoaded] = useState(false);

//   // Cache for payments data
//   const lastFetchTime = useRef(0);
//   const CACHE_LIFETIME = 2 * 60 * 1000; // 2 minutes for payments (more frequent updates)

//   const groupByMonth = (data) => {
//     return data.reduce((acc, item) => {
//       const month = new Date(item.local_date).toLocaleString("default", {
//         month: "long",
//         year: "numeric",
//       });
//       if (!acc[month]) {
//         acc[month] = [];
//       }
//       acc[month].push(item);
//       return acc;
//     }, {});
//   };

//   // Fetch payments data - can fetch partial or all
//   const fetchPayments = useCallback(
//     async (options = {}) => {
//       const {
//         forceRefresh = false,
//         fetchAll = false,
//         pageToken = null,
//       } = options;

//       // Check cache for non-forced refreshes
//       if (
//         !forceRefresh &&
//         !fetchAll &&
//         Date.now() - lastFetchTime.current < CACHE_LIFETIME &&
//         payments.length > 0
//       ) {
//         console.log("Serving payments from cache.");
//         return;
//       }

//       if (!jwt) {
//         setError("Authentication token not available.");
//         return;
//       }

//       setIsLoading(true);
//       setError(null);

//       try {
//         let allPayments = [];
//         let currentPageToken = pageToken;

//         if (fetchAll) {
//           // Fetch all pages at once
//           do {
//             const response = await APICall(
//               "POST",
//               paths.payments.fetch,
//               { next_page_token: currentPageToken || "" },
//               undefined,
//               jwt
//             );

//             if (response?.response?.payments) {
//               allPayments = [...allPayments, ...response.response.payments];
//               currentPageToken = response.response.next_page_token;
//             } else {
//               break;
//             }
//           } while (currentPageToken && currentPageToken !== "END");

//           setPayments(allPayments);
//           setGroupedPayments(groupByMonth(allPayments));
//           setNextPageToken("END");
//         } else {
//           // Fetch single page
//           const response = await APICall(
//             "POST",
//             paths.payments.fetch,
//             { next_page_token: pageToken || "" },
//             undefined,
//             jwt
//           );

//           if (response?.response?.payments) {
//             const newPayments = pageToken
//               ? [...payments, ...response.response.payments]
//               : response.response.payments;

//             setPayments(newPayments);
//             setGroupedPayments(groupByMonth(newPayments));
//             setNextPageToken(response.response.next_page_token);
//           } else {
//             setError("Failed to fetch payments data.");
//           }
//         }

//         lastFetchTime.current = Date.now();
//         setHasInitiallyLoaded(true);
//       } catch (error) {
//         console.error("Error fetching payments:", error);
//         setError("An unexpected error occurred while fetching payments.");
//         setHasInitiallyLoaded(true);
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [jwt]
//     //Removed `payments` from dependency list to avoid unnecessary re-fetching
//   );

//   // Delete payment
//   const deletePayment = useCallback(
//     async (transaction_id, month, year, isCheck) => {
//       try {
//         const queryParams = new URLSearchParams({
//           transaction_id,
//           month,
//           year,
//           is_check: isCheck,
//         }).toString();

//         const urlWithParams = `${paths.payments.delete}?${queryParams}`;

//         const response = await APICall(
//           "DELETE",
//           urlWithParams,
//           undefined,
//           undefined,
//           jwt
//         );

//         if (response.status) {
//           const updatedPayments = payments.filter(
//             (item) => item.entity_id !== transaction_id
//           );

//           setPayments(updatedPayments);
//           setGroupedPayments(groupByMonth(updatedPayments));
//           return true;
//         }
//         return false;
//       } catch (error) {
//         console.error("Error deleting payment:", error);
//         return false;
//       }
//     },
//     [jwt, payments]
//   );

//   const resetPaymentsData = useCallback(() => {
//     setPayments([]);
//     setGroupedPayments({});
//     setError(null);
//     setNextPageToken(null);
//     setHasInitiallyLoaded(false);
//     lastFetchTime.current = 0;
//     console.log("PaymentsContext: State has been reset due to logout.");
//   }, []);

//   // Initial fetch when provider mounts
//   useEffect(() => {
//     if (jwt && !hasInitiallyLoaded) {
//       console.log("PaymentsProvider: JWT found, fetching initial payments.");
//       fetchPayments(); // Fetch first page only
//     } else if (!jwt) {
//       resetPaymentsData();
//     }
//   }, [jwt, fetchPayments, resetPaymentsData, hasInitiallyLoaded]);

//   return (
//     <PaymentsContext.Provider
//       value={{
//         payments,
//         groupedPayments,
//         isLoading,
//         error,
//         nextPageToken,
//         hasInitiallyLoaded,
//         fetchPayments,
//         deletePayment,
//         resetPaymentsData,
//       }}
//     >
//       {children}
//     </PaymentsContext.Provider>
//   );
// };

// // Hook to consume payments data
// export const usePayments = () => {
//   const context = useContext(PaymentsContext);
//   if (context === undefined) {
//     throw new Error("usePayments must be used within a PaymentsProvider");
//   }
//   return context;
// };

import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect,
  useRef,
} from "react";
import APICall from "../Utility/APICall";
import { paths } from "../Utility/Constants";
import { useAuth } from "../Utility/AuthProvider";

// Context for Payments data
export const PaymentsContext = createContext();

// Provider for Payments data
export const PaymentsProvider = ({ children }) => {
  const { jwt } = useAuth();
  const [payments, setPayments] = useState([]);
  const [groupedPayments, setGroupedPayments] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [hasInitiallyLoaded, setHasInitiallyLoaded] = useState(false);

  // Cache for payments data
  const lastFetchTime = useRef(0);
  const CACHE_LIFETIME = 2 * 60 * 1000; // 2 minutes for payments (more frequent updates)

  const groupByMonth = useCallback((data) => {
    return data.reduce((acc, item) => {
      const month = new Date(item.local_date).toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
      if (!acc[month]) {
        acc[month] = [];
      }
      acc[month].push(item);
      return acc;
    }, {});
  }, []);

  // 🔥 NEW: Function to add a new payment locally (for real-time updates)
  const addPaymentLocally = useCallback((newPaymentData) => {
    console.log(
      "🔄 PaymentsContext: Adding new payment locally:",
      newPaymentData
    );

    if (!newPaymentData) {
      console.error(
        "❌ PaymentsContext: No payment data provided to addPaymentLocally"
      );
      return;
    }

    // Create a properly formatted payment object
    const formattedPayment = {
      entity_id: newPaymentData.entity_id || `temp_${Date.now()}`,
      tenant_name: newPaymentData.tenant_name,
      building_name: newPaymentData.building_name,
      unit_name: newPaymentData.unit_name,
      building_id: newPaymentData.building_id,
      unit_id: newPaymentData.unit_id,
      tenant_id: newPaymentData.tenant_id,
      agreement_id: newPaymentData.agreement_id,
      amount: newPaymentData.amount,
      local_amount:
        newPaymentData.local_amount ||
        `₹${parseInt(newPaymentData.amount).toLocaleString("en-IN")}`,
      month: newPaymentData.month,
      year: newPaymentData.year,
      nature: newPaymentData.nature || "rent",
      payment_status: "success",
      payment_mode: newPaymentData.payment_mode || "manual",
      payment_id: newPaymentData.payment_id || "manual",
      description: newPaymentData.description || "",
      local_date: new Date().toLocaleString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }),
      is_check: newPaymentData.is_check || false,
      created: new Date().toISOString(),
      updated: new Date().toISOString(),
    };

    setPayments((prevPayments) => {
      // Check if payment already exists to avoid duplicates
      const existingPayment = prevPayments.find(
        (p) =>
          p.tenant_id === formattedPayment.tenant_id &&
          p.agreement_id === formattedPayment.agreement_id &&
          p.month === formattedPayment.month &&
          p.year === formattedPayment.year &&
          p.nature === formattedPayment.nature
      );

      if (existingPayment) {
        console.log(
          "⚠️ PaymentsContext: Payment already exists, skipping addition"
        );
        return prevPayments;
      }

      // Add the new payment at the beginning of the array (most recent first)
      const updatedPayments = [formattedPayment, ...prevPayments];
      console.log("✅ PaymentsContext: Successfully added new payment");
      return updatedPayments;
    });
  }, []);

  // 🔥 NEW: Function to refresh payments data (can be called externally)
  const refreshPayments = useCallback((options = {}) => {
    console.log("🔄 PaymentsContext: Refreshing payments data");
    lastFetchTime.current = 0; // Reset cache
    return fetchPayments({ forceRefresh: true, ...options });
  }, []);

  // 🔥 ENHANCED: Update groupedPayments whenever payments array changes
  useEffect(() => {
    if (payments.length > 0) {
      const grouped = groupByMonth(payments);
      setGroupedPayments(grouped);
      console.log("📊 PaymentsContext: Updated grouped payments");
    }
  }, [payments, groupByMonth]);

  // Fetch payments data - can fetch partial or all
  const fetchPayments = useCallback(
    async (options = {}) => {
      const {
        forceRefresh = false,
        fetchAll = false,
        pageToken = null,
      } = options;

      // Check cache for non-forced refreshes
      if (
        !forceRefresh &&
        !fetchAll &&
        Date.now() - lastFetchTime.current < CACHE_LIFETIME &&
        payments.length > 0
      ) {
        console.log("💰 PaymentsContext: Serving payments from cache.");
        return;
      }

      if (!jwt) {
        setError("Authentication token not available.");
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        let allPayments = [];
        let currentPageToken = pageToken;

        if (fetchAll) {
          // Fetch all pages at once
          do {
            const response = await APICall(
              "POST",
              paths.payments.fetch,
              { next_page_token: currentPageToken || "" },
              undefined,
              jwt
            );

            if (response?.response?.payments) {
              allPayments = [...allPayments, ...response.response.payments];
              currentPageToken = response.response.next_page_token;
            } else {
              break;
            }
          } while (currentPageToken && currentPageToken !== "END");

          setPayments(allPayments);
          setNextPageToken("END");
        } else {
          // Fetch single page
          const response = await APICall(
            "POST",
            paths.payments.fetch,
            { next_page_token: pageToken || "" },
            undefined,
            jwt
          );

          if (response?.response?.payments) {
            const newPayments = pageToken
              ? [...payments, ...response.response.payments]
              : response.response.payments;

            setPayments(newPayments);
            setNextPageToken(response.response.next_page_token);
          } else {
            setError("Failed to fetch payments data.");
          }
        }

        lastFetchTime.current = Date.now();
        setHasInitiallyLoaded(true);
      } catch (error) {
        console.error("❌ PaymentsContext: Error fetching payments:", error);
        setError("An unexpected error occurred while fetching payments.");
        setHasInitiallyLoaded(true);
      } finally {
        setIsLoading(false);
      }
    },
    [jwt, payments]
  );

  // Delete payment
  const deletePayment = useCallback(
    async (transaction_id, month, year, isCheck) => {
      try {
        const queryParams = new URLSearchParams({
          transaction_id,
          month,
          year,
          is_check: isCheck,
        }).toString();

        const urlWithParams = `${paths.payments.delete}?${queryParams}`;

        const response = await APICall(
          "DELETE",
          urlWithParams,
          undefined,
          undefined,
          jwt
        );

        if (response.status) {
          const updatedPayments = payments.filter(
            (item) => item.entity_id !== transaction_id
          );

          setPayments(updatedPayments);
          console.log("✅ PaymentsContext: Successfully deleted payment");
          return true;
        }
        return false;
      } catch (error) {
        console.error("❌ PaymentsContext: Error deleting payment:", error);
        return false;
      }
    },
    [jwt, payments]
  );

  const resetPaymentsData = useCallback(() => {
    setPayments([]);
    setGroupedPayments({});
    setError(null);
    setNextPageToken(null);
    setHasInitiallyLoaded(false);
    lastFetchTime.current = 0;
    console.log("🔄 PaymentsContext: State has been reset due to logout.");
  }, []);

  // Initial fetch when provider mounts
  useEffect(() => {
    if (jwt && !hasInitiallyLoaded) {
      console.log("🚀 PaymentsContext: JWT found, fetching initial payments.");
      fetchPayments(); // Fetch first page only
    } else if (!jwt) {
      resetPaymentsData();
    }
  }, [jwt, fetchPayments, resetPaymentsData, hasInitiallyLoaded]);

  // 🔥 ENHANCED: Context value with new methods
  const contextValue = {
    payments,
    groupedPayments,
    isLoading,
    error,
    nextPageToken,
    hasInitiallyLoaded,
    fetchPayments,
    deletePayment,
    resetPaymentsData,
    // 🔥 NEW: Real-time update methods
    addPaymentLocally,
    refreshPayments,
  };

  return (
    <PaymentsContext.Provider value={contextValue}>
      {children}
    </PaymentsContext.Provider>
  );
};

// Hook to consume payments data
export const usePayments = () => {
  const context = useContext(PaymentsContext);
  if (context === undefined) {
    throw new Error("usePayments must be used within a PaymentsProvider");
  }
  return context;
};
